import React from 'react';
import { ShieldIcon, BellIcon } from 'lucide-react';
import { currentUser } from '../data/mockData';
interface HeaderProps {
  activeView: string;
  onNavigate: (view: string) => void;
}
export function Header({
  activeView,
  onNavigate
}: HeaderProps) {
  const navItems = [{
    id: 'home',
    label: 'Home'
  }, {
    id: 'knowledge-base',
    label: 'Knowledge Base'
  }, {
    id: 'submit-ticket',
    label: 'Submit Ticket'
  }, {
    id: 'my-tickets',
    label: 'My Tickets'
  }];
  return <header className="bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm" data-id="element-27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="flex justify-between h-16" data-id="element-29">
          {/* Logo & Brand */}
          <div className="flex items-center cursor-pointer" onClick={() => onNavigate('home')} data-id="element-30">
            <div className="flex-shrink-0 flex items-center justify-center w-10 h-10 rounded-lg bg-blue-600 text-white" data-id="element-31">
              <ShieldIcon className="w-6 h-6" data-id="element-32" />
            </div>
            <span className="ml-3 text-xl font-bold text-slate-900 hidden sm:block" data-id="element-33">
              IT Support Portal
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8 items-center" data-id="element-34">
            {navItems.map(item => <button key={item.id} onClick={() => onNavigate(item.id)} className={`px-1 py-2 text-sm font-medium border-b-2 transition-colors ${activeView === item.id ? 'border-blue-600 text-blue-600' : 'border-transparent text-slate-500 hover:text-slate-900 hover:border-slate-300'}`} data-id="element-35">
                {item.label}
              </button>)}
          </nav>

          {/* User Profile & Actions */}
          <div className="flex items-center space-x-4" data-id="element-36">
            <button className="p-2 text-slate-400 hover:text-slate-500 relative" data-id="element-37">
              <BellIcon className="w-5 h-5" data-id="element-38" />
              <span className="absolute top-1.5 right-1.5 block w-2 h-2 rounded-full bg-red-500 ring-2 ring-white" data-id="element-39" />
            </button>

            <div className="flex items-center border-l border-slate-200 pl-4" data-id="element-40">
              <div className="hidden sm:flex flex-col items-end mr-3" data-id="element-41">
                <span className="text-sm font-medium text-slate-900" data-id="element-42">
                  {currentUser.name}
                </span>
                <span className="text-xs text-slate-500" data-id="element-43">
                  {currentUser.role} • {currentUser.department}
                </span>
              </div>
              <div className="w-9 h-9 rounded-full bg-indigo-100 text-indigo-700 flex items-center justify-center font-bold text-sm ring-2 ring-white shadow-sm" data-id="element-44">
                {currentUser.initials}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Navigation (Scrollable) */}
      <div className="md:hidden border-t border-slate-100 overflow-x-auto" data-id="element-45">
        <nav className="flex px-4 space-x-6 min-w-max" data-id="element-46">
          {navItems.map(item => <button key={item.id} onClick={() => onNavigate(item.id)} className={`py-3 text-sm font-medium border-b-2 whitespace-nowrap ${activeView === item.id ? 'border-blue-600 text-blue-600' : 'border-transparent text-slate-500'}`} data-id="element-47">
              {item.label}
            </button>)}
        </nav>
      </div>
    </header>;
}